export default __webpack_public_path__ + "static/Plots0023-f885eaa139dc0e24b80a1372a86ec614.jpg";